import { render, staticRenderFns } from "./TableServComercial.vue?vue&type=template&id=594a1123&"
import script from "./TableServComercial.vue?vue&type=script&lang=js&"
export * from "./TableServComercial.vue?vue&type=script&lang=js&"
import style0 from "./TableServComercial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VTooltip})
